/*
	1R Scripts Entry
*/
import 'Lib/media-check';

/*
	Kick off FE Routing
*/
import 'App/router';

/*
	Extending ORW object
*/
ORW.utilities.mediaCheck = function(entryCallback, exitCallback){
    if (!entryCallback) {
        entryCallback = function(){};
    }
    if (!exitCallback) {
        exitCallback = function(){};
    }
    mediaCheck({
        media: ORW.breakpoint,
        entry: entryCallback,
        exit: exitCallback
    });
}

/*
	Global Function Calls
*/
ORW.utilities.mediaCheck(function () {
    console.log('large screen');
    ORW.responsive = 'large';
}, function () {
    console.log('small screen');
    ORW.responsive = 'small';
});

console.log('ORW Index JS loaded');